import React from 'react';

import { useTheme } from '@mui/material/styles';
import { ProfileSectionPresentation } from './ProfileSection';
import { userProfilesApi } from 'app/store/reducers/api/config-manager-cloud-services/store/user-profiles';
import { useUserStates } from 'app/shared/hooks/restricted/useUserStates';
import { UserRead } from 'app/store/reducers/api/config-manager-cloud-services/store/types';

export const ProfileSection = () => {
  const theme: any = useTheme();
  const { data: userProfile = {} as UserRead } = userProfilesApi.endpoints.getCurrentUserProfile.useQueryState();
  const { currentUserRoles } = useUserStates();

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <ProfileSectionPresentation
      theme={theme}
      anchorRef={anchorRef}
      userProfile={userProfile}
      userRoles={currentUserRoles}
      handleToggle={handleToggle}
      handleClose={handleClose}
      open={open}
    />
  );
};
